import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {AlertController, ToastController} from "ionic-angular";

/*
 Generated class for the ServiceProvider provider.

 See https://angular.io/guide/dependency-injection for more info on providers
 and Angular DI.
 */
@Injectable()
export class ServiceProvider {
    baseUrl: string;
    key = '47f393cfa2eee339cb33c4361319e2f9';
    token: any;
    UserName: any;
    appversioncode: any;
    UserContactNo: any;
    TabsRights = {};
    pages: Array<{ title: string, component: any }>;

    //labels and Icon
    LabelCall = 'Call';
    IconCall = 'md-call';

    LabelCallLogs = 'Call Logs';
    IconCallLogs = 'md-swap';

    LabelDataLogs = 'Data Logs';
    IconDataLogs = 'md-swap';

    LabelDataProcessLogs = 'Data Process Logs';
    IconDataProcessLogs = 'md-swap';

    LabelDataReminderLogs = 'Data Reminder Logs';
    IconDataReminderLogs = 'md-swap';

    LabelSendWpMsg = 'Send WhatsApp Message';
    IconSendWpMsg = 'logo-whatsapp';

    LabelSendTextMsg = 'Send Text Message';
    IconSendTextMsg = 'md-text';

    LabelSendWpGrp = 'Send Message On WhatsApp Group';
    IconSendWpGrp = 'logo-whatsapp';

    LabelAddApt = 'Add Appointment';
    IconAddApt = 'md-calendar';

    LabelSendApt = 'Send Appointment';
    IconSendApt = 'logo-whatsapp';

    LabelSendMsgApt = 'Send Message Appointment';
    IconSendMsgApt = 'logo-whatsapp';

    LabelSendAptMsgWp = 'Send Appointment Message on WhatsApp';
    IconSendAptMsgWp = 'logo-whatsapp';

    LabelSendAptMsgSMS = 'Send Appointment Message on SMS';
    IconSendAptMsgSMS = 'md-text';

    LabelSendAptMsgSMSOnGrp='Send Message On WhatsApp Group';
    IconSendAptMsgSMSOnGrp='logo-whatsapp';

    LabelResApt = 'Reschedule Appointment';
    IconResApt = 'md-swap';

    LabelCancelApt = 'Cancel Appointment';
    IconCancelApt = 'md-calendar';

    LabelEditData = 'Edit Enquiry Data';
    IconEditData = 'md-create';

    LabelEditHistory = 'Edit Enquiry Data History';
    IconEditHistory = 'md-paper';

    LabelAddSib = 'Add Sibling';
    IconAddSib = 'md-contacts';

    LabelSendLoc = 'Send Location';
    IconSendLoc = 'md-pin';

    LabelArchiveData = 'Archive Data';
    IconArchiveData = 'md-archive';

    LabelUnArchiveData = 'UnArchive Data';
    IconUnArchiveData = 'md-refresh-circle';

    LabelAddSubStatus = 'Add SubStatus';
    IconAddSubStatus = 'md-add-circle';

    LabelSubStatusHist = 'SubStatus History';
    IconSubStatusHist = 'md-paper';

    LabelAddCallRem = 'Add Call Reminder';
    IconAddCallRem = 'md-time';

    LabelCancel = 'Cancel';
    IconCancel = 'md-close';

    constructor(public httpClient: HttpClient,
                public alertCtrl: AlertController,
                public toastCtrl: ToastController) {
        console.log('Hello ServiceProvider Provider');
    }


    //Http Call Universal
    public httpcall(url) {
        console.log('this is url' + url);
        return this.httpClient.get(this.baseUrl + url + '&randomvalue=' + Math.random())
            .map(data => {
                //console.log(data['_body']);
                return data;
            });
    }

    public httppostcall(url, data) {
        console.log(url + JSON.stringify(data));
        //return this.httpClient.post(this.baseUrl + url, JSON.stringify(data), {headers:{'Content-Type':'application/json'}})
        return this.httpClient.post(this.baseUrl + url, JSON.stringify(data))
            .map(data => {
                //console.log(data['_body']);
                return data;
            });
    }

    public httppostFormcall(url, data) {
        console.log(url + JSON.stringify(data));
        //return this.httpClient.post(this.baseUrl + url, JSON.stringify(data), {headers:{'Content-Type':'application/json'}})
        return this.httpClient.post(this.baseUrl + url, data)
            .map(data => {
                //console.log(data['_body']);
                return data;
            });
    }

    showAlert(title, Subtitle) {
        const alert = this.alertCtrl.create({
            title: title,
            subTitle: Subtitle,
            buttons: ['OK']
        });
        alert.present();
    }

    showToast(msg) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
}



// WEBPACK FOOTER //
// ./src/providers/service/service.ts